import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { CreateArticleTypeContainer } from './CreateArticleTypeContainer'
import { UpdateArticleTypeContainer } from './UpdateArticleTypeContainer'
import '../../index.css'

import { FetchArticleTypes, FetchArticleTypeImages } from '../../fetcher'
import { ModalView } from '../_reusedcomponents/ModalView'
import AlertMessage from '../alertmessages/AlertMessageView'
import { ArticleTypeView } from './ArticleTypeView'
import { useHandleAlertMessage, useHandleMask } from '../../utils/togglinghooks'
import { MainComponentHeaderView } from '../_reusedcomponents/MainComponentHeaderView'
import { StateSelect, useFilterArticleTypes, useSearchFilter, useSelectFilter } from '../../utils/filterutils'
import { getCsvDataForAllArticleTypes } from '../../utils/csvdatagetter'
import { useSortArticleTypes } from '../../utils/tablehooks'

const ArticleTypeContainer = () => {

    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()
    const [showModal, handleShowModal, handleCloseModal, toggleShowModal] = useHandleMask()
    const [showArticleType, handleShowArticleType, handleCloseArticleType, toggleShowArticleType] = useHandleMask()

    const [filteredArticleTypes, setFilteredArticleTypes] = useState([])
    const [articleTypeDetail, setArticleType] = useState([])
    const [articleTypes, setArticleTypes] = useState([]);
    const [articleDataReady, setArticleDataToReady] = useState(false)
    const [filterable, setFilterable] = useState(false)
    const [ genderSelect, handleGenderSelectChange ] = useSelectFilter()
    const [ sizeCategorySelect, handleSizeCategorySelectChange ] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()
    const { sortArticleTypes } = useSortArticleTypes(articleTypes, setFilteredArticleTypes)
    const { filterArticleTypesBySearchInput, filterArticleTypesBySelectInput } = useFilterArticleTypes()

    /**
     * Adds the corresponding images to the fetched articleTypes via SysIds.
     * @param {object[]} articleTypeImages image datas as binary string
     */
    const addingImages = (articleTypeImages) => {
        let copiedArticleData = [...articleTypes]
        articleTypeImages.forEach(image => copiedArticleData.find(x => x.ArticleTypeSysId == image.ArticleTypeSysId).Image = 'data:image/png;base64,' + image.Data)
        setArticleTypes(copiedArticleData)
    }

    /**
     * Fetches articleTypes and sets them as array via useState "setArticleTypes"
     * sets bool articleDataReady to start image fetching
    */
    useEffect(() => {
        FetchArticleTypes(setArticleTypes, openAlert, setArticleDataToReady)
    }, [])

    /**
     * Fetches images for articleTypes via SysIds if they are already fetched
    */
    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(articleTypes.map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    /**
     * Resets filteredArticleTypes if articleTypes are refetched or reset
    */
    useEffect(() => {
        setFilteredArticleTypes([...articleTypes])
    }, [articleTypes])

    /**
     * Reload function for refetching articleTypes if a new one was created or modified
    */
    const reload = () => {
        setArticleDataToReady(false)
        FetchArticleTypes(setArticleTypes, openAlert, setArticleDataToReady)
    }

    /**
     * UseEffect hook that filters the articleTypes.
     * Executed every time one of the filter/selection inputs changes.
    */
    useEffect(() => {
        let filteredArticleTypes = filterArticleTypesBySearchInput(articleTypes, searchInput)
        filteredArticleTypes = filterArticleTypesBySelectInput(filteredArticleTypes, genderSelect, "Sexes")
        filteredArticleTypes = filterArticleTypesBySelectInput(filteredArticleTypes, sizeCategorySelect, "SizeCategory")

        setFilteredArticleTypes(filteredArticleTypes)
    }, [searchInput, genderSelect, sizeCategorySelect])

    /**
     * Sets the articleType to be opened in the mask for editing
     * @param {object} articleType the articleType to be edited
     */
    const openArticleType = (articleType) => (e) => {
        e.preventDefault()
        //deactivated atm for live version
        //setArticleType(articleType)
        //handleShowArticleType()
    }

    /**
     * Sets the filter menus visibility
    */
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    /**
     * Calls the sortArticleTypes hook
     * @param {any} e default click event
     * @param {string} field string of the field property to be sorted
     */
    const handleSortArticleTypes = (e, field) => {
        e.preventDefault()
        sortArticleTypes(field)
    }

    return (
        <div lang="de">
            <ArticleTypeView openModal={openArticleType} filterable={filterable} filteredArticleTypes={filteredArticleTypes} handleSortArticleTypes={handleSortArticleTypes}
                GenderSelect={StateSelect([...new Set(articleTypes.map(x => x.Sexes))], handleGenderSelectChange, genderSelect)} SizeCategorySelect={StateSelect([...new Set(articleTypes.map(x => x.SizeAttribute.SizeCategory))], handleSizeCategorySelectChange, sizeCategorySelect)}>
                <MainComponentHeaderView title={window.i18n('articleTypes')} filteredElements={filteredArticleTypes} fileName={window.i18n('all_articleTypes')} handleSearchInput={handleSearchInput} setFilterbar={setFilterbar} getCsvData={getCsvDataForAllArticleTypes}>
                    <Button disabled variant="secondary" className="form activity-button" onClick={handleShowModal}>{window.i18n('addArticleType')}</Button>
                </MainComponentHeaderView>
            </ArticleTypeView>

            <ModalView handleShow={showModal} handleClose={handleCloseModal} reload={reload}
                modalTitle={window.i18n('addArticleType')} modalBody={<CreateArticleTypeContainer handleCloseModal={handleCloseModal} openAlert={openAlert} />} formTitle="create-article-form" />

            <ModalView handleShow={showArticleType} handleClose={handleCloseArticleType} reload={reload}
                modalTitle={window.i18n('updateArticleType') + ": '" + articleTypeDetail.Name + "'"}
                modalBody={<UpdateArticleTypeContainer articleTypeDetail={articleTypeDetail} handleCloseArticleType={handleCloseArticleType} openAlert={openAlert} />} formTitle="update-article-form" />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

export { ArticleTypeContainer }